<ul class="bp-toggle-group" [class.small]="isSmall" [class.margin]="margin">
  @for (option of options; track option) {
    <li
      class="bp-toggle-group-item"
      [class.selected]="option.value === selected?.value"
      (click)="onOptionClick(option)"
      (keydown.enter)="onOptionClick(option)"
      [tabindex]="0">
      <span class="white-space-nowrap">{{ option?.label | translate }}</span>
      @if (option.amount) {
        <span class="white-space-nowrap pl-5 amount-color">{{ option?.amount }}</span>
      }
    </li>
  }
</ul>
